// @flow
import styles from './SearchResultSummary.less';

import React from 'react';

import Filters from './Filters/Filters';
import { Text, Strong } from 'seek-style-guide/react';
import CompanySuggestion from '../CompanySuggestion/CompanySuggestion';

type Props = {
  isLoading: boolean,
  isZeroResults: boolean,
  searchParams: ?SearchParams,
  companySuggestion: ?SearchViewModelCompanySuggestion,
  displayTotalCount?: string,
  solMetadataString?: string
};

const SearchResultSummary = ({
  isLoading,
  displayTotalCount,
  isZeroResults,
  searchParams,
  companySuggestion,
  solMetadataString
}: Props) => (
  <div className={styles.root} data-search-sol-meta={solMetadataString}>
    {!isLoading && (
      <div
        id="aria-search-bar"
        aria-live="polite"
        aria-labelledby="SearchSummary"
        role="contentinfo"
        className={styles.flex}
      >
        <Text
          small
          raw
          baseline={false}
          id="SearchSummary"
          data-automation="totalJobsMessage"
        >
          <h1>
            <Strong data-automation="totalJobsCount">
              {displayTotalCount || '0'}
            </Strong>
            {` job${displayTotalCount !== '1' ? 's' : ''}`}
            <span className={styles.textFound}> found</span>
          </h1>
        </Text>
        <Filters />
      </div>
    )}
    {!isZeroResults && (
      <CompanySuggestion
        companySuggestion={companySuggestion}
        searchParams={searchParams}
      />
    )}
  </div>
);

export default SearchResultSummary;
